import masterData from "../masterData";

export const transportationString = (stationInfo, allLine) => {
  const station = masterData.station.byId[stationInfo.station];
  if (!station) {
    return "";
  }
  let lineString = null;
  if (allLine) {
    lineString =
    station.lines &&
    station.lines
      .map(
        (line, lineIndex) =>
          masterData.line.bySlug[line] && masterData.line.bySlug[line].name
      )
      .join(" ");
  } else {
    const line = masterData.line.bySlug[stationInfo.lineSlug];
    lineString =line && line.name
  }
  const distanceMethod = masterData.distanceMethod.byId[stationInfo.method];
  const distanceString = `${distanceMethod.name}${stationInfo.distance}分`;
  return `${lineString} ${station.name}駅 ${distanceString}`;
};

transportationString.injects = ["station", "line"];



// WEBPACK FOOTER //
// ./lib/masterUtil/transportationString.js